/**
 * @description getRemainingTime
 * @params targetTime 目标时间 结束时间
 * @params sourceTime 当前时间 开始时间
 */
export const getRemainingTime = (targetTime, sourceTime) => {
  if (!targetTime || !sourceTime) {
    return
  }
  const pastSeconds = parseInt((new Date(targetTime) - new Date(sourceTime))/1000);
  const pastMinutes = parseInt(pastSeconds / 60);
  const pastHour = parseInt(pastMinutes / 60);
  const pastDay = parseInt(pastHour / 24);
  const pastMonth = getPastMonth(targetTime, sourceTime);
  const pastYear = new Date(targetTime).getFullYear() - new Date(sourceTime).getFullYear();
  let result = ''
  // return `${pastYear}年${pastMonth}月${pastDay}日${pastHour}时${pastMinutes}分${pastSeconds}秒`
  // 1 3 5 7 8 10 12
  // 4 6 9 11
  // 2
  // 7*31 + 4*30 + 2*28
  // **这里的问题，到天可以准确的，因为每月不会都是30天，到算年月会有问题**
  // return `
  //   ${Math.floor(pastSeconds/60/60/24/30/12)?Math.floor(pastSeconds/60/60/24/30/12)+'/':''}${addTimeZero(Math.floor(pastSeconds/60/60/24/30)%12)+'/'}${addTimeZero(Math.floor(pastSeconds/60/60/24)%30)} ${addTimeZero(Math.floor(pastSeconds/60/60)%24)}:${addTimeZero(Math.floor(pastSeconds/60)%60)}:${addTimeZero(pastSeconds%60)}
  // ` // 剩余的时间 独立不关联
  result += `
    ${pastYear+'年'}${addTimeZero(pastMonth%12)+'月'}${addTimeZero(Math.floor(pastSeconds/60/60/24)%30)+'日'} ${addTimeZero(Math.floor(pastSeconds/60/60)%24)}:${addTimeZero(Math.floor(pastSeconds/60)%60)}:${addTimeZero(pastSeconds%60)}
  `
  //  **只算到天是最准确的**
  result += `
    ${addTimeZero(Math.floor(pastSeconds/60/60/24))}天 ${addTimeZero(Math.floor(pastSeconds/60/60)%24)}:${addTimeZero(Math.floor(pastSeconds/60)%60)}:${addTimeZero(pastSeconds%60)}
  `
  return result;
}

function getPastMonth(targetTime, sourceTime) {
  let months = "";
  let nowYear = new Date(targetTime).getFullYear();
  let pastYear = new Date(sourceTime).getFullYear();
  months = (nowYear - pastYear) * 12;
  let nowMonth = new Date(targetTime).getMonth() + 1;
  let pastMonth = new Date(sourceTime).getMonth() + 1;
  let diff = nowMonth - pastMonth;
  months = months + diff;
  return months;
}

function addTimeZero(time) {
  return time < 10 ? `0${time}`:time
}

export const formatDate = (date, fmt) => {
  if (typeof date == 'string') {
    return date;
  }

  if (!fmt) fmt = "yyyy-MM-dd hh:mm:ss";

  if (!date || date == null) return null;
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
